import { render, staticRenderFns } from "./LinkedEventsCard.vue?vue&type=template&id=01703d63&"
import script from "./LinkedEventsCard.vue?vue&type=script&lang=js&"
export * from "./LinkedEventsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports